import React from "react"

import PermissionHolderListItem from "../PermissionHolderListItem"
import { range } from "../../../config/util-functions"
import PermissionHolderListItemShadow from "../PermissionHolderListItemShadow"

const PermissionHoldersViewWidget = ({
    permissionHolders,
    selectedType,
    searchTerm,
    onTypeChange,
    isFetching
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Permissions
        </h3>
        <select
            className="search-bar-container form-control"
            value={selectedType}
            onChange={onTypeChange}
        >
            <option value="viewers">Viewers</option>
            <option value="owners">Owners</option>
        </select>
        <div className="widget-content list-group items-list auto">
            {isFetching &&
                range(10).map(key => (
                    <PermissionHolderListItemShadow key={key} />
                ))}
            {permissionHolders.map(props => (
                <PermissionHolderListItem key={props.id} {...props} />
            ))}
            {permissionHolders.length <= 0 && (
                <p style={{ marginTop: "10px" }}>No {selectedType}</p>
            )}
        </div>
    </div>
)

export default PermissionHoldersViewWidget
